import _ from 'lodash';
import APIClient from './index';

export const getUserTipDefinitions = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('UserTipDefinitions')
      .then(response => resolve(response.data.definitions))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to load user tips.'));
  });
};

export const createUserTipDefinition = definition => {
  return new Promise((resolve, reject) => {
    APIClient.post('UserTipDefinitions', definition)
      .then(response => resolve(response.data.definition))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to create the tip.'));
  });
};

export const updateUserTipDefinition = (id, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`UserTipDefinitions/${id}`, updates)
      .then(response => resolve(response.data.definition))
      .catch(err => reject(_.get(err, 'response.data.error') || 'Failed to update the tip.'));
  });
};
